import Link from "next/link";
import { ReactNode } from "react";

/**
 * A titled module card for the feed's desktop right rail — white surface on the
 * warm page wash, standard card geometry, optional "See all" footer link.
 * Local composition for the feed rail; graduates to the punchup tier
 * (PunchupModuleCard) with the Phase-2 rail work.
 */
export default function RailModule({
  title,
  children,
  seeAllHref,
  onSeeAllClick,
}: {
  title: string;
  children: ReactNode;
  seeAllHref?: string;
  onSeeAllClick?: () => void;
}) {
  return (
    <section className="bg-white border border-[var(--punchup-color-ink-100)] rounded-[14px] p-4">
      <h2 className="text-base font-semibold text-[var(--punchup-color-ink-1000)] mb-3">
        {title}
      </h2>
      <div className="flex flex-col gap-3">{children}</div>
      {seeAllHref && (
        <Link
          href={seeAllHref}
          onClick={onSeeAllClick}
          className="mt-3 pt-3 border-t border-[var(--punchup-color-ink-100)] flex items-center justify-between text-sm font-medium text-[var(--punchup-color-ink-500)] hover:text-[var(--punchup-color-ink-1000)] transition-colors"
        >
          See all
          <span aria-hidden>›</span>
        </Link>
      )}
    </section>
  );
}
